import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import EventsService from "@/services/api/events";
import type { Event } from "@/services/api/events";

export interface EventState {
  events: Event[];
  totalRecord: number;
  isLoading: boolean;
  error: string | null;
}

const initialState: EventState = {
  events: [],
  totalRecord: 0,
  isLoading: false,
  error: null,
};

export const fetchAvailableEvents = createAsyncThunk(
  "events/fetchAvailable",
  async (
    params:
      | {
          page?: number;
          size?: number;
          sort?: string[];
          isEventApplied?: boolean;
        }
      | undefined = undefined,
    { rejectWithValue },
  ) => {
    try {
      const response = await EventsService.getAvailableEvents(params);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch events");
    }
  },
);

const eventSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    clearEvents: (state) => {
      state.events = [];
      state.totalRecord = 0;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAvailableEvents.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAvailableEvents.fulfilled, (state, action) => {
        state.isLoading = false;
        state.events = action.payload.results;
        state.totalRecord = action.payload.totalRecord;
        state.error = null;
      })
      .addCase(fetchAvailableEvents.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
        state.events = [];
      });
  },
});

export const { clearEvents } = eventSlice.actions;
export default eventSlice.reducer;
